import {Col, Form, FormControl, FormControlProps, FormGroup, FormLabel, Row} from "react-bootstrap";
import {Field, FormikErrors, FormikTouched} from "formik";
import React from "react";
import {useTranslation} from "react-i18next";
import NumberFormControl from "./NumberFormControl";
import { flatten } from 'flat'

interface UserInfoStringFlattenFieldProps {
    name: string;
    propName: string;
    type: string;
    value: any | undefined;
    onChange: React.ChangeEventHandler<FormControlProps>;
    touched: FormikTouched<{ [key: string]: any }>;
    errors: FormikErrors<{ [key: string]: any }>;
}

type GenericFlattenedString = {
    [key: string]: string;
};
type GenericFlattenedBoolean = {
    [key: string]: string;
};
export default function UserInfoGenericFlattenSplitFormGroup(
    props: UserInfoStringFlattenFieldProps
) {
    const {t, i18n} = useTranslation();
    const flattenedErrors = flatten(props.errors) as GenericFlattenedString;
    const flattenedTouched = flatten(props.touched) as GenericFlattenedBoolean;
    const error = flattenedErrors[props.propName]?.toString();
    const touched = flattenedTouched[props.propName];

    return (
        <FormGroup className="mb-3">
            <Row>
                <Col xs={6}>
                    <div
                        style={{display: 'flex', alignItems: 'center', height: "100%"}}>
                        <FormLabel
                            className="form-check-inline">{t(`salary.${props.name}`)}</FormLabel>
                    </div>
                </Col>
                <Col xs={6} className="text-end">
                    <Field
                        type={props.type}
                        name= {props.propName}
                        value={props.value}
                        onChange={props.onChange}
                        isInvalid={touched && !!error}
                        as={props.type === "number" ? NumberFormControl : Form.Control}
                    >

                    </Field>
                    {error && touched && (
                        <FormControl.Feedback type="invalid">
                            {error.toString()}
                        </FormControl.Feedback>
                    )}
                </Col>
            </Row>
        </FormGroup>
    )
}